<template>
  <div>
    <navigation-top/>
    <div class="account-container pt-10">
      <div class="card account-card">
        <div class="account-card-menu">
          <div class="account-menu h-100">
            <RouterLink to="/account/profile" active-class="active" class="account-menu-item">
              <v-icon color="primary">mdi-account-box</v-icon>
              <span class="account-menu-item-label">Profile</span>
            </RouterLink>
            <RouterLink to="/account/security" active-class="active" class="account-menu-item">
              <v-icon color="primary">mdi-security</v-icon>
              <span class="account-menu-item-label">Security</span>
            </RouterLink>
            <RouterLink to="/account/integration" active-class="active" class="account-menu-item">
              <v-icon color="primary">mdi-github</v-icon>
              <span class="account-menu-item-label">Integrations</span>
            </RouterLink>
          </div>
        </div>
        <div class="account-card-body">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import NavigationTop from '@/components/NavigationTop.vue'
</script>

<style scoped>
.account-container {
  max-width: 996px;
  margin: 0 auto;
}

.account-card {
  display: flex;
  margin: 0 auto 32px;
  height: 830px;
  padding: 32px 24px !important;
}

.account-card-menu {
  padding-right: 16px;
  border-right: 1px solid var(--light-3);
}

.account-card-body {
  width: 100%;
  height: 100%;
  padding-left: 16px;
}

.account-menu {
  gap: 8px;
  width: 137px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.account-menu-item {
  gap: 8px;
  display: flex;
  padding: 8px;
  border-radius: 42px;
  align-items: center;
  text-decoration: none;

  &.active {
    background: var(--light-2, #F5F2F0);
  }
}

.account-menu-item-label {
  font-size: 14px;
  font-weight: 400;
  color: var(--dark-4, #363A40);
}
</style>
